module.exports = __webpack_public_path__ + "0ac6d54dc46bad9926d1572da75cbcb4.mp4";